/* tslint:disable */
/* eslint-disable */
/**
 * Rapurc API-spec
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Email type enum
 * @export
 * @enum {string}
 */
export enum EmailType {
    BuildingDemolitionContactUpdate = 'BUILDING_DEMOLITION_CONTACT_UPDATE'
}

export function EmailTypeFromJSON(json: any): EmailType {
    return EmailTypeFromJSONTyped(json, false);
}

export function EmailTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailType {
    return json as EmailType;
}

export function EmailTypeToJSON(value?: EmailType | null): any {
    return value as any;
}

